import { useEffect, useRef, useState } from 'react';

// A menu rendered inside the shared Modal: Escape must close only the menu,
// so the key is caught in the capture phase before the Modal's window
// listener sees it.
export const useDismissableMenu = <Element extends HTMLElement>() => {
  const containerRef = useRef<Element>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleMouseDown = (event: MouseEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown, true);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [isOpen]);

  return { containerRef, isOpen, setIsOpen };
};
